import { NamespaceConsumer, NamespaceShape, withNamespace } from '@ux/namespace-component';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Tray title component.
 *
 * Tray titles are for rendering a title inside of the open tray menu.
 *
 * @class TrayTitle
 * @public
 */
class TrayTitle extends NamespaceConsumer {
  /**
   * Render the component.
   *
   * @returns {React.ReactElement} react element
   * @api public
   */
  render() {
    const props = this.props;
    return (
      <div className={ this.namespace('row') }>
        <div className={ this.namespace('col-sm-12') }>
          <div className={ this.namespace('font-primary-bold', 'h3') }>
            { props.children }
          </div>
        </div>
      </div>
    );
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
TrayTitle.propTypes = {
  ...NamespaceShape,
  children: PropTypes.node
};

export default withNamespace(TrayTitle);
